import React from 'react';

/**
 * Riga "Nome commerciale: …" sotto il nome magazzino di un articolo.
 * Non mostra nulla se il nome commerciale manca o coincide con il nome.
 * La visibilità per organizzazione la decide il chiamante (useCommercialNameVisible).
 */
export function CommercialNameLine({ commercialName, productName, className = '' }: {
  commercialName?: string | null;
  productName?: string | null;
  className?: string;
}) {
  const value = commercialName?.trim();
  if (!value || value === productName?.trim()) return null;
  return (
    <p className={`text-xs text-[#37352F] dark:text-gray-200 ${className}`}>
      <span className="text-[#787774] dark:text-gray-400">Nome commerciale:</span> {value}
    </p>
  );
}

export default CommercialNameLine;
